module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "mobile-checkins.c2a4123d.svg";